<!--      Person-->
<div
    [style.min-width]="appService.isMobile() ? '20px' : '200px'"
    style="display: flex; flex-direction: column; justify-content: space-between; height: 100%"
    data-cy="profile-container"
>
    @if (appService.isMobile()) {
        <span class="spacer" data-cy="profile-mobile-spacer-top"></span>
    }
    <button [matMenuTriggerFor]="profileMenu" aria-label="Profile Menu" mat-button data-cy="profile-menu-trigger">
        <div class="one-row" data-cy="profile-button-content">
            @if (thumbnailUrl) {
                <img class="user-avatar" [src]="thumbnailUrl" alt="Profilbild" data-cy="profile-picture" />
            } @else {
                <span class="user-initials" data-cy="profile-initials">{{ initials() }}</span>
            }
            @if (!appService.isMobile()) {
                <span data-cy="profile-user-name"> {{ user()?.firstName }} {{ user()?.lastName }}</span>
            }
            @if (representative?.userHexId && !appService.isMobile()) {
                <span
                    style="margin-left: 6px; color: orangered; font-weight: bold"
                    data-cy="profile-representative-name"
                >({{ representative?.firstName }} {{representative?.lastName}})</span
                >
            }
        </div>
    </button>
    @if (appService.isMobile()) {
        <span class="spacer" data-cy="profile-mobile-spacer-bottom"></span>
    }

    <mat-menu #profileMenu="matMenu">
        @if (appService.isMobile()) {
            <span mat-menu-item style="font-size: 0.9em; color: gray" data-cy="profile-user-name">
                {{ user()?.firstName }} {{ user()?.lastName }}
            </span>
        }

        <button (click)="openProfileSettings()" mat-menu-item data-cy="profile-settings-button">
            <mat-icon>settings</mat-icon>
            <span>Einstellungen</span>
        </button>
        <button (click)="openHelpFeaturesDialog()" mat-menu-item data-cy="profile-help-features">
            <mat-icon>help</mat-icon>
            <span>Hilfe / Features</span>
        </button>
        @if (hasUserGroupViewPermission) {
            <button (click)="changeUser()" mat-menu-item data-cy="profile-change-user">
                <mat-icon>swap_horiz</mat-icon>
                <span>Benutzer wechseln</span>
            </button>
        }
        <button (click)="logout()" mat-menu-item data-cy="profile-logout">
            <mat-icon>logout</mat-icon>
            <span>Abmelden</span>
        </button>
        <button (click)="refresh()" mat-menu-item data-cy="profile-refresh">
            <mat-icon>refresh</mat-icon>
            <span>Session aktualisieren</span>
        </button>
        @if (inSeveralCompanies()) {
            <button (click)="changeCompany()" mat-menu-item data-cy="profile-change-company">
                <mat-icon>apartment</mat-icon>
                <span>Mandant wechseln</span>
            </button>
        }
        @if (phitoSessionService.hasAdminSession()) {
            <button (click)="phitoSessionService.backToAdmin()" mat-menu-item data-cy="profile-back-to-admin">
                <mat-icon>arrow_back</mat-icon>
                <span>Zurück zum Admin</span>
            </button>
        }
        @if (options.version) {
            <span mat-menu-item data-cy="profile-version">
        <span style="color: gray">Version {{ options.version }}</span>
      </span>
        }
    </mat-menu>
</div>
